export const eventNames = {
  NOTIFICATIONS_CREATED: 'notification:created',
  NOTIFICATIONS_CLICKED: 'notification:clicked'
};

/**
 * Constructs an event detail object for notifications
 * @export
 * @param {Object} notification notification object
 * @param {Object} details event details
 * @returns {Object} constructed event
 */
export function constructNotificationEventData(notification, details) {
  return Object.assign({}, details, {
    notification
  });
}
